// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.global-alert div.alert-wrapper:before,
section.global-alert div.alert-wrapper:after,
section.global-alert div.alert-wrapper:before,
section.global-alert div.alert-wrapper:after {
  content: " ";display: table;
}
section.global-alert div.alert-wrapper:after,
section.global-alert div.alert-wrapper:after {
  clear: both;
}
@media (max-width: 598px) {
}@media (min-width: 1024px) {
}@media (min-width: 1512px) {
}@media (min-width: 1024px) {
}section.global-alert {
  margin: 0;
  min-height: 36px;
  color: #FFF;
  font-size: 15px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  border-radius: 0;
  border: none;
  cursor: pointer;
}
section.global-alert.alert-info {
  background: #3C98C7;
}
section.global-alert.alert-warning {
  background: #FCB52B;
}
section.global-alert.alert-success {
  background: #52B382;
}
section.global-alert span.icon {
  order: 1;
  align-self: center;
}
section.global-alert div.alert-wrapper {
  margin-right: auto;
  margin-left: auto;
  padding-left: calc(12px / 2);
  padding-right: calc(12px / 2);
  width: calc(100% + 12px);
  transition: width 0.5s ease-in, height 0.5s ease-in;
  padding: 0 9px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  min-height: 36px;
}
@media (min-width: 599px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(18px / 2);
    padding-right: calc(18px / 2);
    width: calc(599px + 18px);
  }
}
@media (min-width: 736px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(18px / 2);
    padding-right: calc(18px / 2);
    width: calc(736px + 18px);
  }
}
@media (min-width: 1024px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(18px / 2);
    padding-right: calc(18px / 2);
    width: calc(1024px + 18px);
  }
}
@media (min-width: 1128px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(24px / 2);
    padding-right: calc(24px / 2);
    width: calc(1128px + 24px);
  }
}
@media (min-width: 599px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(18px / 2);
    padding-right: calc(18px / 2);
    width: calc(599px + 18px);
  }
}
@media (min-width: 736px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(18px / 2);
    padding-right: calc(18px / 2);
    width: calc(736px + 18px);
  }
}
@media (min-width: 1024px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(18px / 2);
    padding-right: calc(18px / 2);
    width: calc(1024px + 18px);
  }
}
@media (min-width: 1128px) {
  section.global-alert div.alert-wrapper {
    padding-left: calc(24px / 2);
    padding-right: calc(24px / 2);
    width: calc(1128px + 24px);
  }
}
section.global-alert div.alert-content {
  order: 2;
  flex: 3 0;
  text-align: center;
  padding: 0 10px;
  margin: 10px auto;
}
section.global-alert div.alert-content a {
  border: none;
  text-decoration: underline;
  padding-right: 5px;
}
section.global-alert span.close {
  padding-right: 5px;
  order: 3;
  visibility: hidden;
}
section.alert-container .alert {
  margin: 0;
}
section.alert-container .alert .alert-content {
  margin-right: 0;
  text-align: left;
}
section.alert-container .alert .alert-content a {
  border: none;
  color: #3C98C7;
  line-height: inherit;
  margin: 0;
  padding: 0;
}
section.alert-container .alert .alert-content ul {
  list-style-type: disc;
  margin: 0;
}
section.alert-container .alert .alert-content ul li {
  margin: 0 0 6px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
